import { useRef, useCallback, useEffect } from 'react';
import trackIdle from '@framework/browser/timers/trackIdle';
import config from '@framework/config';
import TenantConfig from '@framework/tenant/TenantConfig';
import { SessionService } from '@users/session/SessionService';
import { getContainer } from '@framework/di/getContainer';

export default function useProlong() {
  const container = getContainer();
  const sessionService = container.get<SessionService>(SessionService);

  // @ts-ignore TODO: FIN-32798 strictNullChecks
  let { current: prolongTimer } = useRef(null);
  // @ts-ignore TODO: FIN-32798 strictNullChecks
  let { current: lastProlongTime } = useRef(null);

  /**
   * Will prolong session or reset its state if ssid is not valid
   */
  const prolongSession = useCallback(async () => {
    const session = sessionService.currentSession ?? await sessionService.getCurrentSession();
    // @ts-ignore TODO: FIN-32798 strictNullChecks
    clearTimeout(prolongTimer);
    // @ts-ignore TODO: FIN-32798 strictNullChecks
    lastProlongTime = new Date();
    // @ts-ignore TODO: FIN-32798 strictNullChecks
    let tenant: string;
    if (session) {
      try {
        tenant = TenantConfig.fromHostname().code;
      } catch (e) { /* */ }

      // @ts-ignore TODO: FIN-32798 strictNullChecks
      await sessionService.prolongSession({ tenant });
    }
    // @ts-ignore TODO: FIN-32798 strictNullChecks
    prolongTimer = setTimeout(prolongSession, config.session.prolongInterval);
  }, [lastProlongTime, prolongTimer]);

  /**
   * Init prolong logic and timers
   */
  const initProlong = useCallback(() => {
    prolongSession();
    trackIdle(
      config.session.idleTimeout,
      // @ts-ignore TODO: FIN-32798 strictNullChecks
      () => clearTimeout(prolongTimer),
      () => {
        // @ts-ignore TODO: FIN-32798 strictNullChecks
        const timeSinceLastProlong = (new Date()) - lastProlongTime;
        timeSinceLastProlong >= config.session.prolongInterval
          ? prolongSession()
          // @ts-ignore TODO: FIN-32798 strictNullChecks
          : prolongTimer = setTimeout(prolongSession, config.session.prolongInterval - timeSinceLastProlong);
      },
    );
  }, [prolongSession]);

  useEffect(() => {
    initProlong();
  }, []);

  return {
    initProlong,
    prolongSession,
  };
}
